import React from "react";
import { Trans } from "@lingui/macro";

export const discountOption = <Trans>5% discount</Trans>;
